/**
 * Defines the constants used by the Persistence module.
 * @file
 * @author
 */

export const VUEX_PERSISTENCE_SET_VALUE   = 'VUEX_PERSISTENCE_SET_VALUE'
